// FilterMenu: a filter icon button that opens a context menu for sort and filter choices; it sits next to a search field on phones.
// Props: groups=[{ title, multi (several options can be on; the menu stays open), options: [{ value, label, selected }], onPick(value) }],
//        count (how many filters are on: shown as a badge), onClear (adds "Clear filters" while count > 0), label (aria-label)
(function () {
  const { Box, Typography } = MaterialUI;
  const { useState } = React;

  function FilterMenu({ groups = [], count = 0, onClear, label = 'Sort and filter' }) {
    const { IconButton, Tooltip, Menu, MenuItem, Divider, GoogleIcon } = window.Components;
    const [anchor, setAnchor] = useState(null);
    const rows = [];
    groups.forEach((g, gi) => {
      if (!g.options.length) return;
      if (rows.length) rows.push(<Divider key={`d${gi}`} sx={{ my: 0.5 }} />);
      rows.push(<Typography key={`t${gi}`} role="presentation" variant="labelMedium" sx={{ display: 'block', px: 2, pt: 1, pb: 0.5, color: 'var(--m3-on-surface-variant)' }}>{g.title}</Typography>);
      g.options.forEach(o => rows.push(
        <MenuItem key={`${gi}:${o.value}`} selected={!!o.selected} headline={o.label}
          leadingIcon={<GoogleIcon name={o.selected ? 'check' : 'chevron_right'} size={20} style={{ opacity: o.selected ? 1 : 0 }} />}
          onClick={() => { g.onPick(o.value); if (!g.multi) setAnchor(null); }} />
      ));
    });
    if (count > 0 && onClear) {
      rows.push(<Divider key="dc" sx={{ my: 0.5 }} />);
      rows.push(<MenuItem key="clear" headline="Clear filters" leadingIcon={<GoogleIcon name="filter_alt_off" size={20} />} onClick={() => { onClear(); setAnchor(null); }} />);
    }
    return (
      <>
        <Tooltip title={label}>
          <span>
            <IconButton variant={count ? 'tonal' : 'outlined'} size="large" aria-label={label} aria-haspopup="menu" aria-expanded={!!anchor} onClick={e => setAnchor(e.currentTarget)} sx={{ position: 'relative' }}>
              <GoogleIcon name="tune" size={22} />
              {count > 0 && (
                <Box component="span" aria-label={`${count} on`} sx={{ position: 'absolute', top: 4, right: 4, minWidth: 16, height: 16, px: 0.5, borderRadius: 'var(--m3-shape-full)', display: 'grid', placeItems: 'center', fontSize: 11, fontWeight: 600, lineHeight: 1, backgroundColor: 'var(--m3-primary)', color: 'var(--m3-on-primary)' }}>{count}</Box>
              )}
            </IconButton>
          </span>
        </Tooltip>
        <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)} minWidth={240} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{ sx: { mt: 0.5, maxHeight: 'min(70dvh, 460px)', maxWidth: 'calc(100vw - 32px)' } }} MenuListProps={{ sx: { py: 0 } }}>
          {rows}
        </Menu>
      </>
    );
  }

  window.Components = window.Components || {};
  window.Components.FilterMenu = FilterMenu;
})();
